import React from 'react';

const FavoritesStats = ({ stats }) => {
  if (!stats) return null;

  const { favorites, wishlist } = stats;

  const statCards = [
    {
      label: 'Total Followers',
      value: favorites?.total || 0,
      icon: '❤️',
      color: 'bg-red-50 border-red-200 text-red-700'
    },
    {
      label: 'Active',
      value: favorites?.active || 0,
      icon: '✅',
      color: 'bg-green-50 border-green-200 text-green-700'
    },
    {
      label: 'Snoozed',
      value: favorites?.snoozed || 0,
      icon: '💤',
      color: 'bg-yellow-50 border-yellow-200 text-yellow-700'
    },
    {
      label: 'Inactive',
      value: favorites?.inactive || 0,
      icon: '📴',
      color: 'bg-gray-50 border-gray-200 text-gray-700'
    },
    {
      label: '⭐ Wishlists',
      value: wishlist?.total || 0,
      icon: '⭐',
      color: 'bg-amber-50 border-amber-200 text-amber-700'
    }
  ];

  return (
    <div className="favorites-stats">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {statCards.map((card, index) => (
          <div 
            key={index}
            className={`border rounded-lg p-4 ${card.color}`}
          >
            <div className="flex items-center gap-2">
              <span className="text-2xl">{card.icon}</span>
              <div>
                <p className="text-sm opacity-75">{card.label}</p>
                <p className="text-2xl font-bold">{card.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Wishlist Top Products */}
      {wishlist?.topProducts && wishlist.topProducts.length > 0 && (
        <div className="mt-6">
          <h4 className="text-sm font-medium text-gray-700 mb-3">🏆 Top Wishlisted Products</h4>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
            {wishlist.topProducts.map((product, index) => (
              <div key={product.productId || index} className="border rounded-lg p-3 bg-white">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-bold text-amber-600">#{index + 1}</span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium truncate" title={product.name}>
                      {product.name}
                    </p>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs text-amber-600">⭐ {product.wishlistCount}</span>
                      <span className="text-xs text-gray-400">${product.price.toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Wishlist Trends */}
      {wishlist?.trends && wishlist.trends.length > 0 && (
        <div className="mt-4 text-xs text-gray-500">
          <p>📈 Wishlist activity: {wishlist.trends.length} days with activity</p>
        </div>
      )}

      {stats.communication && (
        <div className="mt-6">
          <h4 className="text-sm font-medium text-gray-700 mb-3">📬 Communication Metrics</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="border rounded-lg p-3 bg-gray-50">
              <p className="text-xs text-gray-500">Messages Sent</p>
              <p className="text-lg font-semibold">{stats.communication.totalMessagesSent || 0}</p>
            </div>
            <div className="border rounded-lg p-3 bg-gray-50">
              <p className="text-xs text-gray-500">Open Rate</p>
              <p className="text-lg font-semibold">{stats.communication.openRate || 0}%</p>
            </div>
            <div className="border rounded-lg p-3 bg-gray-50">
              <p className="text-xs text-gray-500">Reply Rate</p>
              <p className="text-lg font-semibold">{stats.communication.replyRate || 0}%</p>
            </div>
            <div className="border rounded-lg p-3 bg-gray-50">
              <p className="text-xs text-gray-500">Opt-Out Rate</p>
              <p className="text-lg font-semibold">{stats.communication.optOutRate || 0}%</p>
            </div>
          </div>
        </div>
      )}

      {stats.reputation && (
        <div className="mt-6">
          <h4 className="text-sm font-medium text-gray-700 mb-3">⭐ Reputation Scores</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="border rounded-lg p-3 bg-blue-50 border-blue-200">
              <p className="text-xs text-blue-600">Trust Score</p>
              <p className="text-lg font-semibold text-blue-700">{Math.round(stats.reputation.trustScore || 0)}</p>
            </div>
            <div className="border rounded-lg p-3 bg-purple-50 border-purple-200">
              <p className="text-xs text-purple-600">Popularity</p>
              <p className="text-lg font-semibold text-purple-700">{Math.round(stats.reputation.popularityScore || 0)}</p>
            </div>
            <div className="border rounded-lg p-3 bg-green-50 border-green-200">
              <p className="text-xs text-green-600">Engagement</p>
              <p className="text-lg font-semibold text-green-700">{Math.round(stats.reputation.engagementScore || 0)}</p>
            </div>
            <div className="border rounded-lg p-3 bg-amber-50 border-amber-200">
              <p className="text-xs text-amber-600">Reputation</p>
              <p className="text-lg font-semibold text-amber-700">{Math.round(stats.reputation.reputationScore || 0)}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FavoritesStats;
